module.exports = __webpack_public_path__ + "img/ʫƪlogoͼ.a1d68a23.png";